import React from "react";
import { Link } from "react-router-dom";

function SimpleServiceCard({
  img,
  title,
  desc,
  link,
  buttonGroup,
}) {
  return (
    <div className="home-fleet-card d-flex flex-column justify-content-between">
      <div className="home-fleet-card-header">
        <img src={img} alt={title} className="home-fleet-card-img" />
        <h3 className="h3-title mt-4">
          {link ? (
            <Link to={link} className="internal-link">{title}</Link>
          ) : (
            title
          )}
        </h3>
        <p className="home-fleet-card-desc mt-3">{desc}</p>
      </div>
      <div className="home-fleet-btn-group">{buttonGroup}</div>
    </div>
  );
}

export default SimpleServiceCard;
